import { ensureOk } from "@/api/apiError";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/api/httpClient";
import type { AccessRequest } from "@/types";

async function requestAccess(slug: string): Promise<AccessRequest> {
  const response = await httpClient(
    `/agents/${encodeURIComponent(slug)}/access-requests`,
    {
      method: "POST",
    },
  );
  await ensureOk(response);
  return response.json() as Promise<AccessRequest>;
}

async function cancelAccessRequest(slug: string): Promise<void> {
  const response = await httpClient(
    `/agents/${encodeURIComponent(slug)}/access-requests`,
    {
      method: "DELETE",
    },
  );
  await ensureOk(response);
}

/** US-07: request/cancel access to a locked agent. Invalidates the agent catalogue queries
 * so the CTA + access tag reflect the new (server-computed) status immediately. */
export function useRequestAccess() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: requestAccess,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["agents"] });
    },
  });
}

export function useCancelAccessRequest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelAccessRequest,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["agents"] });
    },
  });
}
